import React from 'react';
import { Field, Select, View, Input } from '@components';
import { getConexoesSelect } from '@sdk/Conectores/Conexoes';
import styled from 'styled-components';

const FieldConexao = styled(Field)`
  width: 33%;
`;

const Fields = styled(View)`
  padding-right: 15px;
`;

export default function SelectFonte({ form }) {
  return (
    <Fields>
      <FieldConexao label='Conexão' name='conexao' rules={[{ required: true, message: 'Informe a conexão' }]}>
        <Select form={form} name='conexao' action={() => getConexoesSelect()} placeholder='Selecione uma conexão' autoFocus />
      </FieldConexao>
      <Field label='Comando' name='comando' rules={[{ required: true, message: 'Informe o comando' }]}>
        <Input.TextArea rows={10} />
      </Field>
    </Fields>
  );
}
